common.View.create('Search::bar', {

    onDOMLoad() {
        this.initAjaxSearch();
    },

    initAjaxSearch() {
        // Set timer variable
        let timerDelay;

        // Find search field
        this.element.find('[name="q"]')
            .on('input', (event) => {

                // Save input in variable
                let input = $(event.currentTarget);

                // On more than 2 letters typed
                if ($(input).val().length > 2) {

                    // Clear any previously set timer before setting a fresh one
                    clearTimeout(timerDelay);

                    // Set timer and start search
                    timerDelay = setTimeout((event) => {

                        // Search on page
                        $.get(this.element.find('form').attr('action'), { q: $(input).val() }, (response) => {
                            // Show search results
                            this.element.find('.search-results').removeClass('tw-hidden').html(response);

                            // On focus show again
                            $(input).focus(() => {
                                this.element.find('.search-results').removeClass('tw-hidden').html(response);
                            });

                            // Check for click outside of results
                            $('body')
                                .on('click', (event) => {
                                    let container = this.element;

                                    // Check for click outside div
                                    if( !container.is(event.target) && container.has(event.target).length === 0 ) {
                                        this.element.find('.search-results').html('').addClass('tw-hidden');
                                    }
                                });
                        });

                    }, 500);

                } else {
                    this.element.find('.search-results').html('').addClass('tw-hidden');
                }

            });
    },

});
